/// <amd-module name="Analytics/Shared/ExtensionService/AnalyticsExtensionService" />
import { AnalyticsState, AnalyticsStateDetails } from "Analytics/Common/Contracts/Analytics";
import { IAnalyticsRestClient } from "Analytics/Common/RestClient/Analytics";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssPageService } from "VSS/Platform/Page";

export interface IAnalyticsExtensionStateService extends IVssService {
    isAnalyticsEnabled(): Promise<boolean>;
}

export class AnalyticsExtensionStateService extends VssService implements IAnalyticsExtensionStateService {
    public async isAnalyticsEnabled(): Promise<boolean> {
        const pageData = this.pageContext.getService<IVssPageService>("IVssPageService").getData()!;
        if (pageData.isHosted) {
            return true;
        } else {
            const axClient = this.pageContext.getRestClient<IAnalyticsRestClient>("IAnalyticsRestClient");
            const axStateDetails = await axClient.getState();
            const axState = axStateDetails.analyticsState;
            return axState === AnalyticsState.Preparing || axState === AnalyticsState.Enabled;
        }
    }
}

Services.add("IAnalyticsExtensionStateService", { serviceFactory: AnalyticsExtensionStateService });
